import { render, staticRenderFns } from "./TaskRightTab.vue?vue&type=template&id=7bbfe69c"
import script from "./TaskRightTab.vue?vue&type=script&lang=js"
export * from "./TaskRightTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports